import React, { useContext } from 'react';
// import AppImage from '../AppImage';

import styles from './styles.module.scss';

import SHARED from '../../constants';

import Loader from '../Loader';
import checkCircle from '../../../../assets/imgs/login/checkCircle.svg' 
import { AdminContext } from '../../context/AdminContext';

const LoadingImage = ({
  seleted = false,
  filename = '',
  chooseCoverFromThumbnail,
  id,
  content,
}) => {
  const {themeMode}= useContext(AdminContext)
  return (
    <div
      onClick={() => chooseCoverFromThumbnail(id, filename)}
      className={`${seleted ? styles.redBorder : styles.grayBorder} ${themeMode =="dark" && styles.noBackground}`}
    >
      {filename.length == 0 ? (
        <div className={`flex flex-col justify-center items-center`}>
          <span> {content.creating}</span>
          <Loader
            className={styles.lds_ring}
            // width={`w-20px`}
            // height={`h-20px`}
          />
        </div>
      ) : (
        <div className={`relative w-full h-full cursor-pointer`}>
          <img
            className={`w-full h-full`}
            src={`${SHARED.IMAGE_URL_COPY_API}/${filename}`}
          />
          {seleted && (
            <div className={styles.imageAbsoluteCover}>
              <img
                src={checkCircle}
                alt='checked'
                width={30}
                height={30}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LoadingImage;
